module.exports = __webpack_public_path__ + "static/media/my.5991a60d.svg";